import { BaseInput, BaseInputProps } from "@wise-emotions/react-form-input";
import React, { forwardRef, useImperativeHandle, useRef } from "react";

type Props = Omit<BaseInputProps, "leftSection" | "rightSection">;

const BirthdateInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

  return (
    <BaseInput
      {...props}
      ref={inputRef}
      inputMode="numeric"
      type="text"
      aria-errormessage="birthdate-validation"
    />
  );
});

export default BirthdateInput;
